import Axios from 'axios';
import Cookies from 'js-cookie';

import {
    API,
    AUTH_ERROR,
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    SET_LOGIN_VISIBILITY,
    USER_LOADED,
    USER_LOADING
} from './types';

import { get } from 'lodash';
import { pushAlert } from './alertActions';
import { loadNotifications } from './notificationActions';

// Check token & load user
export const loadUser = () => (dispatch) => {
    // User loading
    dispatch({ type: USER_LOADING });
    const token = Cookies.get('token');

    dispatch({
        type: API,
        payload: {
            url: 'user/check',
            method: 'GET',
            ...tokenConfig(),
            onSuccess: (data) => {
                Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                dispatch({
                    type: USER_LOADED,
                    payload: { ...data, token: token }
                });
                dispatch(loadNotifications());
            },
            onFailure: (e) =>
                dispatch({
                    type: AUTH_ERROR
                })
        }
    });
};

export const loginWithToken = (token, user) => (dispatch) => {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    Cookies.set('token', token, {
        domain: process.env.NEXT_PUBLIC_DOMAIN || '.sportision.de'
    });

    dispatch({
        type: LOGIN_SUCCESS,
        payload: { user, token }
    });
};

// Login User
export const login =
    (
        username,
        password,
        { before = () => {}, success = () => {}, failure = (response, data) => {}, finish = () => {} }
    ) =>
    (dispatch) => {
        dispatch({
            type: API,
            payload: {
                url: 'login',
                method: 'POST',
                data: {
                    username: username.trim(),
                    password: password.trim()
                },
                muted: true,
                onSuccess: (data) => {
                    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
                    Cookies.set('token', data.token, {
                        domain: process.env.NEXT_PUBLIC_DOMAIN || '.sportision.de'
                    });

                    dispatch({
                        type: LOGIN_SUCCESS,
                        payload: data
                    });
                    success();
                },
                onFailure: (e) => {
                    Cookies.remove('token', {
                        domain: process.env.NEXT_PUBLIC_DOMAIN || '.sportision.de'
                    });
                    dispatch({
                        type: LOGIN_FAIL
                    });
                    failure(
                        get(e, 'data.message') ||
                            'Der Login war leider nicht erfolgreich! Benutzername oder Passwort falsch!',
                        e.data
                    );
                },
                onBefore: before,
                onFinish: finish
            }
        });
    };

// Logout User
export const logout = () => (dispatch) => {
    Axios.defaults.headers.common['Authorization'] = null;
    Cookies.remove('token', {
        expires: 14,
        domain: process.env.NEXT_PUBLIC_DOMAIN || '.sportision.de'
    });
    dispatch({
        type: LOGOUT_SUCCESS
    });
    dispatch(pushAlert('Du wurdest erfolgreich ausgeloggt!', 'success'));
};

// Setup config/headers and token
export const tokenConfig = (pToken) => {
    // Get token from Cookies
    const token = Cookies.get('token');

    // Headers
    const config = {
        headers: {
            'Content-type': 'application/json'
        }
    };

    // If token, add to headers
    if (pToken) {
        config.headers['Authorization'] = 'Bearer ' + token;
    } else if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
};

// Open interactive Login
export const setLoginVisibility = (visibility) => {
    return {
        type: SET_LOGIN_VISIBILITY,
        payload: visibility
    };
};
